import { Fade, Modal, IconButton } from "@material-ui/core";
import { Image } from "react-bootstrap";
import MapIconJobDetail from "src/imagesV2/MapIconJobDetail.svg";
import closeIcon from "src/imagesV2/FacilityDetailsModal/closeIcon.svg";
import instagramIcon from "src/imagesV2/FacilityDetailsModal/instagram.svg";
import facebookIcon from "src/imagesV2/FacilityDetailsModal/facebook.svg";
import websiteIcon from "src/imagesV2/FacilityDetailsModal/website.svg";
import {
  isTablet,
  isBrowser,
} from "react-device-detect";
import styles from "./FacilityDetailsModal.module.scss";

interface JobDetailsObjectProps {
  atsJobId: string;
  professionCode: string;
  specialty: string;
  state: string;
  city: string;
  zip: string;
  shift: string;
  type: string;
  weeklyPay: string;
  facilityName: string;
  sourceSubArea: string;
  specialtyCode: string;
  salaryMax: number;
  isQuickApplied: boolean;
}

interface FacilityDetailsModalProps {
  isOpen: boolean;
  handleClose: () => void;
  jobDetailsObject: JobDetailsObjectProps;
}

const FacilityDetailsModal = ({
  isOpen,
  handleClose,
  jobDetailsObject,
}: FacilityDetailsModalProps) => {
  return (
    <Modal open={isOpen} onClose={handleClose} closeAfterTransition className={styles.modal}>
      <Fade in={isOpen}>
        <div className={styles.content}>
          {/* Head Content */}
          <div className={styles.headeContent}>
            <div className={styles.heading}>
              <span>Facility Details</span>
            </div>
            <div className={styles.closeIconContainer}>
              <IconButton aria-label="close" onClick={handleClose}>
                <img src={closeIcon} alt="close-icon" />
              </IconButton>
            </div>
          </div>
          {/* Video Content */}
          <div className={styles.mainContent}>
            <div className={styles.videoContent}>
              <iframe
                src="https://www.youtube.com/embed/YLN1Argi7ik"
                title="Professional, Corporate, Small Business Stock Footage Highlight Reel"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className={styles.video}
              />
            </div>
            {/* Main Content */}
            <div className={styles.facilityDetails}>
              <div className={styles.facilityHeading}>
                <span className={styles.facilityName}>{jobDetailsObject?.facilityName}</span>
                <p className={styles.facilityLocation}>
                  <span>
                    <Image src={MapIconJobDetail} className="mapIconJobDetail" />
                    {jobDetailsObject?.city
                      ? `${jobDetailsObject.city}, ${jobDetailsObject.state}`
                      : jobDetailsObject.state}
                  </span>
                </p>
              </div>
              <div className={styles.facilityContent}>
                {isBrowser || isTablet ? (
                  <>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus eos aperiam
                      odio quibusdam ex amet non laboriosam officiis impedit veniam. Ipsam nobis
                      aliquam magni veniam qui corrupti numquam tempora eaque.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus eos aperiam
                      odio quibusdam ex amet non laboriosam officiis impedit veniam. Ipsam nobis
                      aliquam magni veniam qui corrupti numquam tempora eaque.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus eos aperiam
                      odio quibusdam ex amet non laboriosam officiis impedit veniam. Ipsam nobis
                      aliquam magni veniam qui corrupti numquam tempora eaque.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus eos aperiam
                      odio quibusdam ex amet non laboriosam officiis impedit veniam. Ipsam nobis
                      aliquam magni veniam qui corrupti numquam tempora eaque.
                    </p>
                  </>
                ) : (
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus eos aperiam odio
                    quibusdam ex amet non laboriosam officiis impedit veniam. Ipsam nobis aliquam
                    magni veniam qui corrupti numquam tempora eaque.
                  </p>
                )}
              </div>
            </div>
            {/* Footer Content */}
            <div className={styles.socailLinksContainer}>
              <div className={styles.socialLinkBox}>
                <Image src={instagramIcon} alt="instagram" />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>@luriechildrensnurses</span>
                  <span>@luriechildrensnurses</span>
                  <span>@luriechildrensnurses</span>
                  <span>@luriechildrensnurses</span>
                </div>
              </div>
              <div className={styles.socialLinkBox}>
                <Image src={facebookIcon} alt="facebook" />
                <span>Lurie Children’s</span>
              </div>
              <div className={styles.socialLinkBox}>
                <Image src={websiteIcon} alt="website" />
                <span>www.luriechildrens.org</span>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default FacilityDetailsModal;
